import {Component, ElementRef, ViewChild} from '@angular/core';
import {MenuItemsProvider} from "../../providers/menu-items/menu-items";
import {NavController} from "ionic-angular";
import {AuthService} from "../../services/AuthService";
import {OperationService} from "../../services/OperationService";
import {OperationCard} from "../../model/OperationCard";
import {OrderService} from "../../services/OrderService";
import {ActivityDate, ActivityWeek, DateService} from "../../services/DateService";
import {Address, Retailer, StoreLocation} from "../../model/Store";
import {OperationDashboardPage} from "../operation-dashboard/operation-dashboard";
import {PlanningMissionPurpose} from "../../model/OrderRequest";
import {PhotoService} from "../../services/PhotoService";
import {MissionReportPhoto} from "../../model/MissionReportPhoto";
import {AgencyConfigService} from "../../services/AgencyConfigService";
import {apiconfig, ApplicationConfig, getAppConfiguration} from "../../app/api.config";
import {AgencyConfigData} from "../../model/Agency";
import {LggContext, OrderListPage} from "../order-list/order-list";
import {Locupa2Service} from "../../services/Locupa2Service";
import {Activity} from "../../model/Order";
import {Operation} from "../../model/Operation";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
import {PowerBIService} from "../../services/PowerBIService";

declare var google;

export class HomePageDailyPlanning {
  planningEntryType: string;

  context: string;

  id: number;
  day: number;
  amStartTime: string;
  amEndTime: string;
  pmStartTime: string;
  pmEndTime: string;
  location: StoreLocation;
  duration: string;

  //activity for LOGA, if loaded as a Loga planning entry. Will be null if Pearls entry
  logaActivity: Activity;
  logaOperation: Operation;

  operationLogoUrl: string;
  hrStatus: string;
  cssStatus: string;

  plannedPurposes: PlanningMissionPurpose[];
  presence: boolean;
  pictures: MissionReportPhoto[] = [];

}

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {


  iconsURL: string = apiconfig.LOGA_ICONS;

  @ViewChild('map') mapElement: ElementRef;
  map: any;

  private currentWeek: ActivityWeek;
  today: ActivityDate;

  public showPresenceCheckInfosPerOp: Map<number, boolean>;
  public showPresenceCheckPhotos: Map<number, boolean>;
  public showCraPhotos: Map<number, boolean>;

  appConfig: ApplicationConfig = getAppConfiguration();
  agency: AgencyConfigData = this.agencyConfigService.getAgencyConfigData();


  /**
   * collection of Operation Cards loaded with report information, used to display the short list of operation below the main menu
   */
  uiOperationCards: OperationCard[];

  /**
   * ui toggle to display / hide inactive operations
   */
  uiShowInactiveOperations: boolean;

  /**
   * list of activities to display as a fast preview of the activity
   */
  uiDailyPlanning: HomePageDailyPlanning[];

  locupa2tokenUrl: string = this.locupa2Service.getLocupa2TokenUrl();

  pearlsContexts: LggContext[];
  pearlsContextLogo: Map<number, SafeUrl> = new Map<number, SafeUrl>();

  constructor(
    private navCtrl: NavController,
    private operationService: OperationService,
    public menuItemsProvider: MenuItemsProvider,
    private orderService: OrderService,
    private dateService: DateService,
    private photoService: PhotoService,
    private agencyConfigService: AgencyConfigService,
    public authService: AuthService,
    private locupa2Service: Locupa2Service,
    private domSanitizer: DomSanitizer,
    private powerBIService: PowerBIService) {

    window.addEventListener('message', (event) => {
      if (event.origin === this.agencyConfigService.getAgencyConfigData().locupa2) {
        console.log('Home: Received message from locupa2 :', event.data);

        this.redirectToPage(event);
      }
    });
  }

  ionViewWillEnter() {

    //by default, it makes sense to show only currently active operations
    this.uiShowInactiveOperations = false;

    this.currentWeek = this.dateService.getCurrentWeek();

    this.currentWeek.activityDates.forEach(d => {
      if (d.isToday()) {
        this.today = d;
      }
    });

    this.orderService.loadLggContexts().then((contexts) => {
      this.pearlsContexts = contexts;
      contexts.forEach(c => {
        this.loadPearlsLogo(c.value);
      })

    })

    let that = this;
    this.operationService.loadOperationCards().then(cards => {
      this.uiOperationCards = cards;
      return cards;
    }).then(cards => {

      let allOperationIds: number[] = [];
      for (let c of this.uiOperationCards)
        allOperationIds.push(c.id);

      this.showPresenceCheckInfosPerOp = new Map();
      this.showPresenceCheckPhotos = new Map();
      this.showCraPhotos = new Map();

      let allP = [];
      for (let id of allOperationIds) {
        allP.push(this.operationService.loadOperationCustomerPlanningSettings(id).then(planificationSettings => {
          this.showPresenceCheckInfosPerOp.set(id, planificationSettings.showPresenceCheckInfos)
          this.showPresenceCheckPhotos.set(id, planificationSettings.showCheckInQuestionnaire !== 'NO');
          this.showCraPhotos.set(id, planificationSettings.showCra !== 'NO');
        }));
      }
      return Promise.all(allP);

    }).then(() => {
      this.menuItemsProvider.updateFromOperationCards(this.uiOperationCards);
    }).then(() => {

        this.orderService.loadOrderReport(this.currentWeek.getStartDate(), this.currentWeek.getEndDate(), undefined)
          .then(report => {

            console.log("Order report loaded", report);

            if (report != null) {

              // collect order(missino) ids in order to load additional content later on, for instance pictures
              let missionIds: number[] = [];

              // we put a fake missionId in order to avoid to have an empty array, as the API would believe we want to load all, when really if there is no mission, we don't want to load addition content like pictures
              missionIds.push(0);

              for (const day of report.days) {
                if (day.logaDay === this.today.dateStamp) {

                  console.log(" op report = " + day.operationReports.length)

                  for (const operationReport of day.operationReports) {
                    // read Order Mission from LOga
                    for (const o of operationReport.planningEntry.missions) {

                      if (o.activities != null) {

                        missionIds.push(o.id);

                        o.activities.forEach(act => {
                          if (act.day == this.today.dateStamp) {

                            let dp = new HomePageDailyPlanning();
                            dp.planningEntryType = operationReport.planningEntry.planningEntryType;

                            dp.id = act.id;
                            dp.day = act.day;
                            dp.logaActivity = act;
                            dp.logaOperation = o.operation;

                            if (act.amStartTime && act.amEndTime) {
                              dp.amStartTime = this.dateService.toTime(act.amStartTime);
                              dp.amEndTime = this.dateService.toTime(act.amEndTime);
                            }

                            if (act.pmStartTime && act.pmEndTime) {
                              dp.pmStartTime = this.dateService.toTime(act.pmStartTime);
                              dp.pmEndTime = this.dateService.toTime(act.pmEndTime);
                            }

                            dp.location = o.location;
                            dp.context = o.operation.name;

                            dp.hrStatus = o.toHrStatus();
                            dp.cssStatus = o.cssStatus();

                            that.uiOperationCards.forEach(opCard => {
                              if (opCard.id == o.operation.id)
                                dp.operationLogoUrl = opCard.operationLogoUrl;
                            })

                            //legacy behaviour with mono purpose
                            if (o.planningPurpose && (dp.plannedPurposes == null || dp.plannedPurposes.length == 0)) {
                              let e = new PlanningMissionPurpose();
                              e.instructions = '';
                              e.purposeName = o.planningPurpose.name;
                              e.purposeId = o.planningPurpose.id;
                              dp.plannedPurposes.push(e);
                            }

                            dp.presence = o.presence;

                            this.uiDailyPlanning.push(dp);

                            this.addMarker(dp);

                          }
                        });
                      }
                    }

                    // read  Pearls planning
                    if (operationReport.planningEntry.pearlsPlanningEntries) {
                      for (const pearlsPlanningEntry of operationReport.planningEntry.pearlsPlanningEntries) {

                        if (pearlsPlanningEntry.planningEntryType === 'STORECHECK') {

                          let dp = new HomePageDailyPlanning();
                          dp.planningEntryType = pearlsPlanningEntry.planningEntryType;

                          dp.amStartTime = pearlsPlanningEntry.startTime;
                          dp.amEndTime = pearlsPlanningEntry.endTime;

                          dp.context = operationReport.label;

                          dp.location = new StoreLocation();
                          dp.location.name = pearlsPlanningEntry.storeName;
                          dp.location.address = new Address();
                          dp.location.address.city = pearlsPlanningEntry.address.city;
                          dp.location.address.administrativeArea = pearlsPlanningEntry.address.administrativeArea;
                          dp.location.address.lat = pearlsPlanningEntry.address.lat;
                          dp.location.address.lon = pearlsPlanningEntry.address.lon;
                          dp.location.retailer = new Retailer();
                          dp.location.retailer.name = pearlsPlanningEntry.retailerName;

                          dp.hrStatus = pearlsPlanningEntry.toHrStatus();
                          dp.cssStatus = pearlsPlanningEntry.statusClass;
                          dp.duration = pearlsPlanningEntry.hrDuration;

                          this.uiDailyPlanning.push(dp);

                          this.addMarker(dp);
                        }

                      }
                    }
                  }
                }
              }

              console.log("missionIds", missionIds)

              this.photoService.searchPhoto(null, null, null, null, missionIds)
                .then((missionsPhotoReport: MissionReportPhoto[]) => {

                  let animaToken: string;
                  let logaToken: string = this.authService.buildLogaToken();

                  if (missionsPhotoReport != null)
                    missionsPhotoReport.forEach((ph) => {
                      for (let act of this.uiDailyPlanning) {
                        if (act.id == ph.activityId) {

                          switch (ph.source) {
                            case "PCHECK":
                              logaToken = this.authService.buildLogaToken();
                              ph.urlPicture = ph.urlPicture + "&jtkn=" + logaToken;
                              ph.urlThumbnail = ph.urlThumbnail + "&jtkn=" + logaToken;
                              break;
                            case "COACHING":
                              logaToken = this.authService.buildLogaToken();
                              ph.urlPicture = ph.urlPicture + "&jtkn=" + logaToken;
                              ph.urlThumbnail = ph.urlThumbnail + "&jtkn=" + logaToken;
                              break;
                            case "ANIMA_TAG_PHOTO":
                              animaToken = this.authService.buildAnimaInputFieldToken(ph.logaWorkDayId);
                              ph.urlPicture = ph.urlPicture + "&tkn=" + animaToken;
                              ph.urlThumbnail = ph.urlThumbnail + "&tkn=" + animaToken;
                              break;
                            case "ANIMA_ISA_PHOTO":
                              animaToken = this.authService.buildAnimaInputFieldToken(ph.logaWorkDayId);
                              ph.urlPicture = ph.urlPicture + "&tkn=" + animaToken;
                              ph.urlThumbnail = ph.urlThumbnail + "&tkn=" + animaToken;
                              break;
                            case "ANIMA_PRODUCT_PHOTO":
                              animaToken = this.authService.buildAnimaInputFieldToken(ph.logaWorkDayId);
                              ph.urlPicture = ph.urlPicture + "&tkn=" + animaToken;
                              ph.urlThumbnail = ph.urlThumbnail + "&tkn=" + animaToken;
                              break;
                            default:
                              console.log("Unknown source:" + ph.source)
                              break;
                          }

                          act.pictures.push(ph);
                        }
                      }
                    });
                });
            }

          });

        this.uiDailyPlanning.sort(((a, b): number => {
          if (a.amStartTime != null && b.amStartTime != null)
            return (a.amStartTime > b.amStartTime) ? 1 : -1;
        }));

      }
    );

    this.uiDailyPlanning = [];

  }

  loadPearlsLogo(contextId: number) {
    this.orderService.loadPearlsLogo(contextId).subscribe({
      next: (response: any) => {
        if (response && response.content) {
          this.pearlsContextLogo.set(contextId, this.domSanitizer.bypassSecurityTrustUrl('data:image/jpg;base64,' + response.content))
        }
      }
    });
  }

  private addMarker(dp: HomePageDailyPlanning) {

    // add marker
    let latLng = new google.maps.LatLng(dp.location.address.lat, dp.location.address.lon);
    if (this.map == null) {
      let mapOptions = {
        center: latLng,
        zoom: 6,
        disableDefaultUI: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      }
      this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    }

    if (dp.location.address.lat != null && dp.location.address.lat != 0) {

      let marker = new google.maps.Marker({
        map: this.map,
        animation: google.maps.Animation.DROP,
        position: latLng
      });

      let content = '';
      content += '<img class="map-bubble-retailer" src="' + this.iconsURL + '/' + dp.location.retailer.name + '/32.png"><img>';
      content += "<b>" + dp.location.name + "</b><br/>";
      content += "<span>" + dp.location.address.administrativeArea + '-' + dp.location.address.city + "</span><br/>";

      /*if (plannedPurpose != null && (plannedPurposes == null || plannedPurposes.length == 0)) {
          content += "<span>" + plannedPurpose.name + "</span><br/>";
      }*/
      if (dp.plannedPurposes != null) {
        for (let pp of dp.plannedPurposes) {
          content += "<span>" + pp.purposeName + "</span><br/>";
        }
      }
      this.addInfoWindow(marker, content);

    }

  }

  /**
   *
   * @param marker
   * @param content
   */
  private addInfoWindow(marker, content) {
    let infoWindow = new google.maps.InfoWindow({
      content: content
    });
    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, marker);
    });
  }

  /**
   * logout from the application
   */
  logout() {
    this.authService.logOut();
    window.location.reload();
    this.locupa2Service.closeWindow();
  }

  /**
   * callback for menu selection, simply open the appropriate page
   * @param p
   */
  open(p
       :
       {
         title: string;
         i18nKey: string;
         component: any;
         locupa2Route?: string;
         icon: any;
         badgeValue: any;
         moduleColor: string;
         showOnMenu: boolean
       }
  ) {
    if (p.component) {
      this.navCtrl.setRoot(p.component);
    } else if (p.locupa2Route) {
      if (p.locupa2Route === 'power-bi-embed') {
        this.powerBIService.openPowerBIEmbed(`/${p.locupa2Route}`);
      } else {
        this.locupa2Service.openLocupa2Window(`/${p.locupa2Route}`);
      }
    }
  }


  /**
   * open the Active Operation Home Page from the main menu
   * @param opCard
   */
  openOperationDashboard(opCard
                         :
                         OperationCard
  ) {
    this.navCtrl.push(OperationDashboardPage, {'operationCard': opCard});
  }


  computeStart(act: HomePageDailyPlanning) {
    if (act.amStartTime != null) return act.amStartTime;
    else return act.pmStartTime;
  }


  toFormatMissionDuration(hpAct: HomePageDailyPlanning) {

    let act = hpAct.logaActivity;

    if (act == null) {
      return hpAct.duration;
    }

    let nbMinAm: number = 0;
    let nbMinPm: number = 0;
    if (act.amStartTime && act.amEndTime)
      nbMinAm += Math.abs(act.amEndTime.valueOf() - act.amStartTime.valueOf()) / (1000 * 60);

    if (act.pmStartTime && act.pmEndTime)
      nbMinPm += Math.abs(act.pmEndTime.valueOf() - act.pmStartTime.valueOf()) / (1000 * 60);
    let durationInMinutes = Math.abs(Number(nbMinAm) + Number(nbMinPm));

    let nbHours = Math.floor(durationInMinutes / 60);
    let nbMinutes = Math.floor(durationInMinutes % 60);

    if (nbMinutes && nbMinutes > 0) {
      return nbHours + "h" + nbMinutes;
    }

    return nbHours + "h";
  }

  computeTitleForImg(ph: MissionReportPhoto): string {
    if (ph.tagName != null) return ph.tagName;
    if (ph.dataModelName != null) return ph.dataModelName;
    if (ph.dataModelName != null) return ph.dataModelName;
    if (ph.source == "PCHECK") return "Controle de Présence";
    return null;
  }

  initLocupa2Token() {

    // we need to wait a bit until the frame is loaded...
    // https://stackoverflow.com/questions/76384092/origin-error-when-using-postmessage-from-parent-to-iframe-failed-to-execute-po
    setTimeout(() => {
      console.log("sending token to L2..")

      let data = {token: this.authService.loggedUser.jwtToken, username: this.authService.loggedUser.login};
      let iframeEl = document.getElementById("locupa2iFrame");

      if (iframeEl) {
        // @ts-ignore
        iframeEl.contentWindow.postMessage(JSON.stringify(data), this.locupa2Service.getLocupa2Url());
      } else {
        console.log('cannot find locupa2iFrame');
      }
    }, 1500);
  }

  /**
   *
   * @param id
   */
  openPearlsDashboard(p_ctxId: any) {
    this.locupa2Service.openLocupa2Window(`/pearls-dashboard/` + p_ctxId);
  }

  getPearlsLogo(contextId: number) {
    return this.pearlsContextLogo.get(contextId);
  }

  redirectToPage(event) {
    if (!event.data || !event.data.page)
      return;

    this.locupa2Service.closeWindow();

    switch (event.data.page) {
      case 'PLANNING': {
        this.navCtrl.setRoot(OrderListPage);
        break;
      }
      case 'HOME': {
        this.navCtrl.setRoot(HomePage);
        break;
      }
      default: {
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts